<template>
    <a href="#" @click="click()" :class="[{ loading : parentLoading }, 'vuecheckbox']">
        <i v-if="isChecked" class="fas fa-check-square green"></i>
        <i v-else-if="isPartial" class="fas fa-check-square amber"></i>
        <i v-else-if="isUnChecked" class="far fa-square"></i>
        <i v-else class="fas fa-minus-square"></i>
    </a>
</template>

<script>
    export default {

        props: {
            state: {
                required: true,
            },
            parentLoading: {
                required: true,
            },
        },

        methods: {
            click(event) {
                this.$emit('clicked')
            }
        },

        computed: {
            isChecked() {
                return this.state==='checked' || this.state === 1 || this.state === true;
            },
            isPartial() {
                return this.state === 'partial';
            },
            isUnChecked() {
                return this.state==='unchecked' || this.state === 0 || this.state === false;
            },
        }

    }
</script>

<style>
    .vuecheckbox, a.vuecheckbox {
        font-size: 22px;
        height: 45px;
        width: 45px;
        flex: 0 0 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
        outline: 0;
    }
    a.vuecheckbox:hover, a.vuecheckbox:active, a.vuecheckbox:focus {
        text-decoration: none;
    }
    .loading { opacity: 0.75 }
    .green { color: #1b8a1b; }
    .amber { color: #e09100; }
</style>
